module.exports = __webpack_public_path__ + "47fc1add/img/product-icon-grey.b248963c.svg";